<template>
  <Transition
    name="fade-transition"
    :appear="true"
    :css="false"
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @leave="onLeave"
  >
    <slot />
  </Transition>
</template>

<script>
import { defaultDuration, calculateDuration, createTween, runAnimation, chainTween } from '@src/components/Transitions/utils/transitionHelpers';

export default {
  name: 'FadeTransition',
  props: {
    duration: {
      type: Number,
      default: defaultDuration,
    },
  },
  methods: {
    onBeforeEnter(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.opacity = 0;
    },

    onEnter(el, done) {
      runAnimation(
        createTween(
          {
            start: { opacity: 0 },
            end: { opacity: 1 },
            duration: calculateDuration('enter', defaultDuration, this.duration),
          },
          (object) => {
            // eslint-disable-next-line no-param-reassign
            el.style.opacity = `${object.opacity}`;
          },
          () => {
            done();
          },
        ),
      );
    },

    onLeave(el, done) {
      runAnimation(
        createTween(
          {
            start: { opacity: 1 },
            end: { opacity: 0 },
            duration: calculateDuration('leave', defaultDuration, this.duration),
          },
          (object) => {
            // eslint-disable-next-line no-param-reassign
            el.style.opacity = `${object.opacity}`;
          },
          () => {
            done();
          },
        ),
      );
    },
  },
};

</script>
